import '../../../mixins.js'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
//import Plotly from 'plotly.js-basic-dist-min'
var Plotly = require('./../../../custom_bundles/custom-plotly.js');
import { mapGetters } from 'vuex'

export default {
  name: 'performance',
  components: {spinner},
  data() {
    return {
      responseData : null,
      selected:'',
      benchmarks: [],
      days: -1,
      benchmarkOption: false,
      id : this.$route.params.id,
      PortfolioEmpty: false,
      timeOption: false,
      showPerformanceSpinner: false
    }
  },
  async created(){

  },
  beforeMount () {

    
    
  },
  mounted () {
    this.loadData();
    //this.addBenchmarks();
    this.buttonActivation("nav-bar-plot", "btn")
    window.addEventListener("resize", this.myEventHandler);
  }, 
  computed: {
    ...mapGetters(['get_SP_portfolioData'])
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {

    async plotPortfolioRisk(days, divName) {
      Plotly.purge(divName)
      this.showPerformanceSpinner = true; 

      var days_options = [30, 180, 365, -1];
      var current;
      var i;
      for (i = 0; i < days_options.length; i++) {
          current = document.getElementById(days_options[i]);
        if(days == days_options[i])
        {
           current.className = "chart_time active";
        }
        else{
          current.className ="chart_time";
        }

      }

      console.log("risk plot")
      this.benchmarkOption = false;
      this.riskOption = true;
      this.dividendOption = false;
      var day_key;

      switch(days){
        case 30:
          day_key = "1m";
          break; 
        case 180:
          day_key = "6m";
          break; 
        case 365:
          day_key = "1y";
          break; 
        default:
          day_key = "total";
      }

//      try{
        if (this.benchmark_data == null){
          var payload = {"hash_id":this.id, first_date: this.stockData.dates[0]};
          this.benchmark_data = await this.postEndpointNoVerify(payload, "benchmarkSharedPortfolios/?format=json")
          this.addBenchmarks();
        }
        var PortfolioReturns = this.benchmark_data["user_benchmarks"]["portfolio_return"][day_key];
        var PortfolioVolatility = this.benchmark_data["user_benchmarks"]["portfolio_volatility"][day_key];
        
        var benchmarkPortfolioReturns = PortfolioReturns.slice(1);
        var benchmarkPortfolioVolatility = PortfolioVolatility.slice(1);

        var portfolioReturn =  PortfolioReturns[0]; // as given in percentage points
        var portfolioVolatility =  PortfolioVolatility[0]; // as given in percentage points
        
        var indexReturns =  this.benchmark_data["index_benchmarks"]["portfolio_return"][day_key]; // as given in percentage points
        var indexVolas =  this.benchmark_data["index_benchmarks"]["portfolio_volatility"][day_key]; // as given in percentage points
        var indexNames =  this.benchmark_data["index_benchmarks"]["names"]; // as given in percentage points

    
        var volatilities_bm = {
          x:benchmarkPortfolioVolatility,
          y:benchmarkPortfolioReturns,
          type:'scatter',
          mode: 'markers',
          opacity:1,
          hovertemplate : "Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          marker: {
            color: ['#333333'],
            size: 12
          }
          ,
          hover_data:["portfolio"]
        };

        var volatilities_user = {
          x:[portfolioVolatility],
          y:[portfolioReturn],
          type:'scatter',
          mode: 'markers',
          opacity:1,
          hovertemplate : "Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          marker: {
            color: ['#FF6816'],
            size: 12
          }
          ,
          hover_data:["portfolio"]
        };

        var index_benchmarks = {
          x:indexVolas,
          y:indexReturns,
          type:'scatter',
          mode: 'markers',
          opacity:0.5,
          text : indexNames,
          hovertemplate : "%{text} <br>Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          hoverinfo:"x+y",
          marker: {
            color: ['#333333'],
            size: 12,
            symbol: 'x'
          }

        };
        var max_vola = Math.max.apply(Math, indexVolas.concat(portfolioVolatility, benchmarkPortfolioVolatility)) + 0.025
        var data_prices = [volatilities_bm, index_benchmarks, volatilities_user];
    
            var layout_prices = {
              paper_bgcolor:'rgba(0,0,0,0)',
              plot_bgcolor:'rgba(0,0,0,0)',
              hovermode:'closest',
              hovertemplate: '<extra></extra>',
              autosize:true,
              showlegend:false,
              xaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)',  tickformat: ',.2%', title:'Jahresvolatilität', fixedrange: true, range:[0, max_vola]},
              yaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)',  tickformat: ',.2%', title:'Rendite', fixedrange: true},
              margin:{
                'l':80,
                'r':25,
                'b':40,
                't':25,
                'pad':2
            },

            };
        
            var config = {
              displayModeBar: false,
            };
            this.showPerformanceSpinner = false;

  
            Plotly.newPlot(divName, data_prices, layout_prices, config);

    },

      normalizeValues: function(stockPrices) {
        var i;
        var normalized_values = [];  
      for (i = 0; i < stockPrices.length; i++) {
        normalized_values.push(100*stockPrices[i]/stockPrices[0]);
      }
    return normalized_values;
    
    },
    loadData: async function() {
      this.portfolioBenchmark = this.get_SP_portfolioData;
      if (Object.keys(this.portfolioBenchmark).length === 0){
        this.PortfolioEmpty = true;
      }
      else{
      this.stockData = {name: 'Portfolio', dates: this.portfolioBenchmark.date, prices: this.portfolioBenchmark.indexed_net_portfolio_values};
      console.log(this.stockData)
      this.plotPortfolioTimeSeries( -1, 'chart');
      var currButt = document.getElementById(-1);
      currButt.className = "chart_time active";
      }
  },
    myEventHandler() {
      this.plotActiveTimeSeries(this.days)
    },
    plotActiveTimeSeries(days) {
      this.days = days;
      var days_options = [30, 180, 365, -1];
      var current;
      var i;
      for (i = 0; i < days_options.length; i++) {
          current = document.getElementById(days_options[i]);
        if(days == days_options[i])
        {
           current.className = "chart_time active";
        }
        else{
          current.className ="chart_time";
        }

      }
      if(document.getElementById('return_evolution').classList.contains("active"))
      {
        this.plotPortfolioTimeSeries(days, 'chart');
      }
        else{
          this.plotPortfolioRisk(days, 'chart');
        }
  
    }, 
    plotPortfolioTimeSeries: async function(days, divName) {
      this.timeOption = true;
      this.days = days;
      var stockName = this.stockData["name"]

      var stockDatesTotal = this.stockData["dates"];
      var stockDataTotal = this.stockData["prices"];

      // additional slicing
      if (days != -1){ // send -1 to request full horizon
        stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - days, 0))
        stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - days, 0))
      }

      // normalize the data
      stockDataTotal = this.normalizeValues(stockDataTotal);
      var stock = {
        x:stockDatesTotal,
        y:stockDataTotal,
        mode:'lines',
        line:{'width':3, color:'#FF6816'},
  
        opacity:1,
        name: stockName,
        hovertemplate: '%{y}<extra></extra>'

      };
  
          var data_prices = [stock];
  
          var layout_prices = {
            paper_bgcolor:'#FFFFFF',
            plot_bgcolor:'#FFFFFF',
            hovermode:'x',
            autosize:true,
            legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.5},
            xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true},
            yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
            margin:{
              'l':45,
              'r':25,
              'b':25,
              't':25,
              'pad':2
          },

          };
      
          var config = {
            displayModeBar: false,
          };
          
          Plotly.newPlot(divName, data_prices, layout_prices, config);
    },
  }

}